export default __webpack_public_path__ + "static/media/mobile_pay.4737c828.png";